<div id="bca-choose-extras">
  <div class="tile__title">
    <nes-heading tag="h2" size="6xl" class="nes-mb-3">
      {{ "COMPOSE.CHOOSE_EXTRAS.TITLE_INFORMAL" | translate }}
    </nes-heading>
  </div>
  <div>
    <div class="nes-flex nes-flex-col nes-gap-5 nes-mb-5">
      <ng-container
        *ngFor="let addon of selectedProduct.addons; trackBy: trackByIdentifier"
      >
        <bca-product-addon
          [addon]="addon"
          [routeLoading]="
            (routeLoading$ | async) &&
            selectedProduct.identifier === ProductIdentifier.Traject
          "
          (selected)="onAddonSelected(addon, $event)"
        >
        </bca-product-addon>
      </ng-container>
    </div>

    <div class="nes-mb-10">
      <div class="nes-mb-3">
        <nes-heading
          tag="h3"
          size="base"
          class="nes-font-bold nes-text-blue nes-m-0"
        >
          {{ "COMPOSE.CHOOSE_EXTRAS.SERVICES.TITLE" | translate }}
        </nes-heading>
        <nes-text>
          {{ "COMPOSE.CHOOSE_EXTRAS.SERVICES.EXPLAINER" | translate }}
        </nes-text>
      </div>
      <div class="nes-mb-3">
        <div class="nes-flex nes-gap-3">
          <nes-heading
            tag="h3"
            size="base"
            class="nes-font-bold nes-text-blue nes-m-0"
          >
            {{ "COMPOSE.CHOOSE_EXTRAS.SERVICES.OPEN_TITLE" | translate }}
          </nes-heading>
          <nes-tooltip nes-id="dtd-services-tooltip">
            {{ "COMPOSE.CHOOSE_EXTRAS.SERVICES.OPEN_TOOLTIP" | translate }}
          </nes-tooltip>
        </div>
        {{ "COMPOSE.CHOOSE_EXTRAS.SERVICES.OPEN_EXPLAINER" | translate }}
      </div>

      <div class="nes-flex">
        <nes-selectable
          #useExtrasButtonTrue
          class="nes-mr-3 nes-w-5/12 sm:nes-w-3/12 nes-flex nes-justify-items-center"
          id="useExtrasButtonTrue"
          nes-id="useExtrasButtonTrue"
          [label]="'COMPANY_DATA.TOGGLE_BUTTON.YES' | translate"
          name="option-yes"
          [checked]="!(servicesExpanded$ | async)"
          (nesOnClick)="toggleServicesExpandedOld(true)"
        >
          <div class="nes-py-4 nes-text-center">
            {{ "COMPANY_DATA.TOGGLE_BUTTON.YES" | translate }}
          </div>
        </nes-selectable>

        <nes-selectable
          #useExtrasButtonFalse
          class="nes-w-5/12 sm:nes-w-3/12 nes-flex nes-justify-items-center"
          id="useExtrasButtonFalse"
          nes-id="useExtrasButtonFalse"
          [label]="'COMPANY_DATA.TOGGLE_BUTTON.NO' | translate"
          name="option-no"
          [checked]="servicesExpanded$ | async"
          (nesOnClick)="toggleServicesExpandedOld(false)"
        >
          <div class="nes-py-4 nes-text-center">
            {{ "COMPANY_DATA.TOGGLE_BUTTON.NO" | translate }}
          </div>
        </nes-selectable>
      </div>
      <ng-container *ngIf="servicesExpanded$ | async">
        <div
          id="services"
          class="collapsibleTile__content animated fadeIn nes-mt-5"
        >
          <ng-container
            *ngFor="
              let service of selectedProduct.services;
              let even = even;
              trackBy: trackByIdentifier
            "
          >
            <bca-product-service
              (selected)="onServiceSelected(service, $event)"
              [service]="service"
              [tooltip]="
                'COMPOSE.CHOOSE_EXTRAS.SERVICES.' +
                service.identifier +
                '.TOOLTIP'
              "
              [isEven]="even"
            >
            </bca-product-service>
          </ng-container>
        </div>
      </ng-container>
    </div>

    <div class="lg:nes-hidden" *ngIf="showProductInfo$ | async">
      <nes-highlight-box type="info">
        <ns-product-info (action)="onActionClicked($event)"></ns-product-info>
      </nes-highlight-box>
    </div>

    <div class="mt-3">
      <div class="nes-flex nes-justify-between nes-items-center nes-flex-wrap">
        <nes-button
          icon-leading="plus-circle"
          variant="tertiary"
          id="order_more_cards_button"
          [disabled]="!(allowNewProduct$ | async) || (routeLoading$ | async)"
          (click)="addProduct.emit()"
        >
          <span class="nes-font-remi-bold"></span>
          {{ "BUTTON.ADD_PRODUCT" | translate }}
        </nes-button>

        <nes-button
          variant="brand"
          icon-trailing="true"
          nes-id="to_userdata_page"
          id="to_userdata_page"
          [disabled]="routeLoading$ | async"
          (click)="nextPage.emit()"
        >
          <span class="s-hidden m-visible">
            {{ "BUTTON.CONTINUE_DESKTOP" | translate }}
          </span>
          <span class="s-visibile m-hidden">
            {{ "BUTTON.CONTINUE_MOBILE" | translate }}
          </span>
        </nes-button>
      </div>
    </div>
  </div>
</div>
